import React from "react";
import { CaseStageEnum } from "../../../../../src/api/caseStages";
import { useAppSelector } from "../../../../../src/app/store";
import { useLoggedInUserId } from "../../../../../src/features/auth/logic/rbac";
import { selectCurrentCaseStage } from "../../../../../src/features/caseinfo/logic/Slice";
import WorkflowStageBanner from "../../../../../src/features/stageWorkflow/components/WorkflowStageBanner";
import WorkflowStageInfoBanner from "../../../stageWorkflow/components/WorkflowStageInfoBanner";
import { selectStageConfigByStage } from "../../logic/slice";
import { selectParticipantByType } from "../../../../../src/features/caseinfo/logic/ParticipantsSlice";
import { ParticipantType } from "../../../../../src/api/participants";

export const FwdAuthCaseReviewStage: React.FC = () => {
  const loggedInUserId = useLoggedInUserId();

  const forwardingAuthorityParticipant = useAppSelector((state) =>
    selectParticipantByType(state, ParticipantType.FORWARDING_AUTHORITY)
  );

  const forwardingAuthority = forwardingAuthorityParticipant?.participant_id;

  const stageConfig = useAppSelector(selectStageConfigByStage(CaseStageEnum.FWD_AUTH_CASE_REVIEW));

  const isForwardingAuthority = loggedInUserId === forwardingAuthority;

  const currentStage = useAppSelector(selectCurrentCaseStage);
  
  const notes = currentStage?.stage_data?.notes;

  if (isForwardingAuthority) {
    return (
      <WorkflowStageBanner
        title="Review New Case"
        description="A new case was initiated. Accept to forward it to FRMD, Return to Initiator for additional information or Reject, as required."
        actions={stageConfig?.actions}
        notes={notes}
      />
    );
  }

  return (
    <WorkflowStageInfoBanner title="Pending with Forwarding Authority for Case Review" />
  );
};
